// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cWjK","fullView":"styles_fullView__UBWe1"};